import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EditLockbox extends Vue {
   public title: string = 'EditLockbox';

   @Prop()
   public data: any;

   @Prop()
   public saveCallback: any;

   @Prop()
   public cancelCallback: any;

   @Prop()
   public index: any;

   public isShow = true;

   public save() {
      this.saveCallback(this.index, this.data);
   }

   public cancel() {
      this.cancelCallback();
   }

}
